import {
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Table,
  Tag,
  Typography,
  Tooltip,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import Page from "_components/Page";
import { materialDetailService } from "_services";
import MaterailDetailSearch from "../Search";
import { BarcodeOutlined } from "@ant-design/icons";
import { Auth } from "_helpers";

const StrGrList = ({ history, match }) => {
  const { path } = match;
  const [loading, setLoading] = useState(false);
  const [loadingBarcodes, setLoadingBarcodes] = useState(false);
  const [items, setItems] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [totalRecords, setTotalRecords] = useState(0);
  const [totalGrossMeasure, setTotalGrossMeasure] = useState(0);
  const [searchParams, setSearchParams] = useState("");
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const loggedInCustomerCode = Auth.getProfile().comp_code;

  const { Text } = Typography;

  useEffect(() => {
    //getItems(pageNumber, pageSize);
  }, []);

  const getItems = (pageNumber, pageSize) => {
    let paginationParams = searchParams.indexOf("?") === -1 ? "?" : "&";
    paginationParams += `pageNumber=${pageNumber}&pageSize=${pageSize}`;

    setLoading(true);
    materialDetailService
      .search(`${searchParams}${paginationParams}`)
      .then((data) => {
        setItems(data.content);
        setLoading(false);
        setTotalRecords(data.pagination.totalRecords);
        const grossMeasures = Object.values(data.pagination.totalGross);
        const grossMeasureSum =
          grossMeasures.length > 0 &&
          grossMeasures.reduce((prev, next) => prev + next);
        setTotalGrossMeasure(grossMeasureSum);
        setPageNumber(pageNumber);
        setPageSize(pageSize);
      })
      .catch((error) => {
        setLoading(false);
        message.error(`${error}`);
      });
  };

  const handleSearchResults = (results, pagination, searchParams) => {
    setItems(results);
    if (pagination) {
      setTotalRecords(pagination.totalRecords);
      const grossMeasures = Object.values(pagination.totalGross);
      const grossMeasureSum =
        grossMeasures.length > 0 &&
        grossMeasures.reduce((prev, next) => prev + next);
      setTotalGrossMeasure(grossMeasureSum);
    }
    setSearchParams(searchParams);
    setPageNumber(1);
    setLoading(false);
  };

  const handlePaginateChange = (pageNumber, pageSize) => {
    //console.log("Page ChANGE:", pageNumber, ", pageSize:", pageSize);
    getItems(pageNumber, pageSize);
  };

  const onSelectChange = (selectedRowKeys) => {
    //console.log("selectedRowKeys changed: ", selectedRowKeys);
    setSelectedRowKeys(selectedRowKeys);
    setSelectedItems(
      items
        .filter((item) => selectedRowKeys.includes(item.id))
        .map((item) => ({
          id: item.id,
          packSerial: item.packSerialNo,
          runningNo: item.runningNo,
          mergeNo: item.lotNumber.number,
          itemCode: item.stockType.code,
          quantity: item.quantity,
          netWeight: item.netWeight,
          grossWeight: item.grossWeight,
        }))
    );
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [Table.SELECTION_ALL, Table.SELECTION_INVERT],
  };

  const handleBinTransfer = () => {
    const stockItems = items.filter(
      (item) => selectedRowKeys.includes(item.id) && item.mode === "AVAILABLE"
    );

    if (stockItems.length > 0 && selectedRowKeys.length === stockItems.length) {
      history.push({
        pathname: `${path}/bin-transfer`,
        store: stockItems[0].owner,
        storeLocation: stockItems[0].stockBin.storeLocation,
        stockItems: stockItems,
      });
    } else {
      message.info("Please select only available stocks to be transfer");
    }
  };

  const handleGenerateBarcodes = () => {
    if (selectedRowKeys.length > 0) {
      const payload = {
        stockItems: selectedRowKeys.map((item) => ({
          id: item,
        })),
      };
      setLoadingBarcodes(true);
      materialDetailService
        .generateAndDownloadBarcodes(payload)
        .then((response) => {
          const url = window.webkitURL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `Barcodes_${moment(new Date()).format("YYYY-MM-DD")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoadingBarcodes(false);
        })
        .catch((error) => {
          setLoadingBarcodes(false);
          message.error(error);
        });
    }
  };

  const getActionButtons = () => {
    let buttons = [];
    if (selectedRowKeys.length > 0) {
      buttons.push(
        <span style={{ marginLeft: 8 }}>
          Selected {selectedRowKeys.length} items
        </span>
      );
    }
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Button
          key="barcode"
          icon={<BarcodeOutlined />}
          disabled={selectedRowKeys.length === 0}
          onClick={handleGenerateBarcodes}
          loading={loadingBarcodes}
        ></Button>
      );
      buttons.push(
        <Button
          key="bin-transfer"
          disabled={selectedRowKeys.length === 0}
          onClick={handleBinTransfer}
        >
          Bin Transfer
        </Button>
      );
    }
    return buttons;
  };

  const getColumns = () => {
    let columns = [];
    columns.push({
      title: "Material Type",
      dataIndex: "stockType",
      key: "stockType",
      width: "15%",
      render: (text, record) => {
        return (
          <>
            <Link to={`/material-details/${record.id}/summary`}>
              {record.stockType.code}
            </Link>
            <Input value={record.id} hidden />
          </>
        );
      },
    });
    /* columns.push({
      title: "Description",
      key: "stockTypeName",
      width: "10%",
      ellipsis: {
        showTitle: false,
      },
      render: (text, record) => {
        return (
          <Tooltip placeholder="topLeft" title={record.stockType.name}>
            {record.stockType.name}
          </Tooltip>
        );
      },
    }); */
    columns.push({
      title: "Batch",
      dataIndex: "lotNumber",
      key: "lotNumber",
      width: "10%",
      render: (text, record) => {
        return record.lotNumber && record.lotNumber.number;
      },
    });
    columns.push({
      title: "Box S/N",
      dataIndex: "serialNo",
      key: "serialNo",
      width: "%8",
    });
    columns.push({
      title: "Invoice No:",
      key: "preReceiptNumber",
      width: "15%",
      render: (text, record) => {
        return (
          record.stockPreReceiptLine &&
          record.stockPreReceiptLine.stockPreReceipt &&
          record.stockPreReceiptLine.stockPreReceipt.preReceiptNumber
        );
      },
    });
    columns.push({
      title: "Stock Bin",
      dataIndex: "stockBin",
      key: "stockBin",
      width: "10%",
      render: (text, record) => {
        return record.stockBin.code;
      },
    });
    columns.push({
      title: "Delivery No:",
      key: "deliveryNumber",
      width: "15%",
      render: (text, record) => {
        return (
          record.issuedLine &&
          record.issuedLine.stockIssue &&
          record.issuedLine.stockIssue.issueNumber
        );
      },
    });
    columns.push({
      title: "Status",
      dataIndex: "mode",
      key: "mode",
      width: "6%",
      render: (text) => {
        let color = "";
        if (text === "AVAILABLE") {
          color = "#87d068";
        }
        if (text === "REQUESTED") {
          color = "#2db7f5";
        }
        if (text === "ISSUED") {
          color = "#108ee9";
        }
        if (text === "DELIVERED") {
          color = "#f50";
        }
        return <Tag color={color}>{text}</Tag>;
      },
    });
    columns.push({
      title: "Net Weight",
      dataIndex: "netWeight",
      key: "netWeight",
      align: "right",
      width: "6%",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
    });
    columns.push({
      title: "Gross Weight",
      dataIndex: "grossWeight",
      key: "grossWeight",
      align: "right",
      width: "6%",
      render: (text, record) => {
        return text && Number(text).toFixed(2);
      },
    });
    columns.push({
      title: "UOM",
      dataIndex: "measurementType",
      key: "measurementType",
      width: "4%",
      render: (text, record) => {
        return record.measurementType && record.measurementType.name;
      },
    });
    columns.push({
      title: "Due Days",
      key: "dueDays",
      width: "5%",
      render: (text, record) => {
        return (
          record.stockPreReceiptLine &&
          record.stockPreReceiptLine.stockPreReceipt &&
          moment(moment()).diff(
            record.stockPreReceiptLine.stockPreReceipt.orderDate,
            "days"
          )
        );
      },
    });

    return columns;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/material-details">Material Detail Search</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <MaterailDetailSearch
            showSearchLoading={setLoading}
            onSearchResults={handleSearchResults}
            loggedInCustomerCode={loggedInCustomerCode}
          />
          <Table
            bordered
            loading={loading}
            rowKey="id"
            size="small"
            columns={getColumns()}
            dataSource={items}
            rowSelection={rowSelection}
            pagination={{
              current: pageNumber,
              pageSize: pageSize,
              total: totalRecords,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              onChange: handlePaginateChange,
            }}
            summary={() => {
              return (
                <>
                  <Table.Summary.Row>
                    <Table.Summary.Cell colSpan={7}>
                      <Text strong>Total</Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      <Text strong style={{ paddingLeft: 12 }}>
                        {totalRecords}
                      </Text>
                    </Table.Summary.Cell>
                    <Table.Summary.Cell>
                      {/* <Text strong>
                        {!isNaN(totalGrossMeasure) &&
                          Number(totalGrossMeasure).toFixed(2)}
                      </Text> */}
                    </Table.Summary.Cell>
                    <Table.Summary.Cell/>
                    <Table.Summary.Cell></Table.Summary.Cell>
                    <Table.Summary.Cell></Table.Summary.Cell>
                  </Table.Summary.Row>
                </>
              );
            }}
          />
        </Page>
      </PageHeader>
    </div>
  );
};

export default StrGrList;
